/*
 * @Author: whitechiina 1293616053@qq.com
 * @Date: 2026-01-26 15:47:43
 * @LastEditors: whitechiina 1293616053@qq.com
 * @LastEditTime: 2026-01-26 17:58:20
 * @FilePath: /传媒后台管理系统/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 配置Axios基础URL
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3000/api'
Vue.prototype.$http = axios

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js